export const ADMIN_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME = Symbol('admin.profile-settings.general-settings');
export const AFFILIATE_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME = Symbol('affiliate.profile-settings.general-settings');

export const ADMIN_PROFILE_SETTINGS_GENERAL_SETTINGS_SAVE_URL = 'admin/profile/data_update';
export const AFFILIATE_PROFILE_SETTINGS_GENERAL_SETTINGS_SAVE_URL = 'affiliate/settings/data_update';
export const PROFILE_SETTINGS_GENERAL_SETTINGS_SAVE_MUTATION_KEY = 'profile-settings.general-settings.save';
